import React, { useState, useEffect, Fragment } from "react";
import { Tooltip } from "antd";
import DownloadStatements from "./downloadStatements";
import DownloadVerificationDocs from "./downloadVerificationDocs";
import ExportDataModal from "./ExportHierarchyAccount";
import DownloadAchWireDetails from "./downloadAchWireDetails";
import HideOnMobile from "../../../../../../components/generic/hideOnMobile";
import EntityToBankAccountSetRelation from "../../../../../../components/bankAccount/modals/entityToBankAccountSetRelation";
import UnassignEntityFromBankAccounts from "../../../../../../components/bankAccount/modals/unassignEntityFromBankAccounts";
import UpdateAccountNumbers from "../../../../../../components/bankAccount/modals/updateAccountNumbers";
import GenericDropdown from "../../../../../../components/generic/genericDropdown";
import ExportConnectedAccountModal from "./ExportConnectedAccountModal";
import { useUcs } from '../../../../../../helpers/contexts/UserCompanySettingsContext'


function ConnectedAccountsTableDropdown(props) {
  const [csvModalVisible, setCsvModalVisible] = useState(false);
  const [showStatementModal, setShowStatementModal] = useState(false);
  const [showVerificationDocModal, setShowVerificationDocModal] = useState(false);
  const [showAchWireDetailsModal, setShowAchWireDetailsModal] = useState(false);
  const [showBankAccountToEntitySetRelationModal, setShowBankAccountToEntitySetRelationModal] = useState(false);
  const [showUnassignEntityFromBankAccountsModal, setShowUnassignEntityFromBankAccountsModal] = useState(false);
  const [showUpdateAccountNumbersModal, setShowUpdateAccountNumbersModal] = useState(false);
  const [dropdownItems, setDropdownItems] = useState([])

  const [isDashboardEditor, setIsDashboardEditor] = useState(false)

  const ucsContext = useUcs()

  useEffect(() => {
    if (ucsContext.loaded) {
      setIsDashboardEditor(ucsContext.isDashboardEditor())
    }
  }, [ucsContext])


  useEffect(() => {
    let newDropdownItems = []

    newDropdownItems.push(
      <Tooltip title={props.selectedRows.length === 0 ? "No accounts selected" : undefined}>
        <a
          onClick={props.selectedRows.length === 0 ? undefined : () => setShowStatementModal(true)}
          style={{ cursor: props.selectedRows.length === 0 ? "not-allowed" : "pointer", }}
        >
          Download Statements
        </a>
      </Tooltip>
    )

    newDropdownItems.push(
      <Tooltip title={props.selectedRows.length === 0 ? "No accounts selected" : undefined}>
        <a
          onClick={props.selectedRows.length === 0 ? undefined : () => setShowVerificationDocModal(true)}
          style={{ cursor: props.selectedRows.length === 0 ? "not-allowed" : "pointer", }}
        >
          Download Verification Documents
        </a>
      </Tooltip>
    )

    newDropdownItems.push(
      <Tooltip title={props.selectedRows.length === 0 ? "No accounts selected" : undefined}>
        <a
          onClick={props.selectedRows.length === 0 ? undefined : () => setShowAchWireDetailsModal(true)}
          style={{ cursor: props.selectedRows.length === 0 ? "not-allowed" : "pointer", }}
        >
          Download ACH/Wire Details
        </a>
      </Tooltip>
    )

    if (isDashboardEditor) {
      newDropdownItems.push(
        <Tooltip title={props.selectedRows.length === 0 ? "No accounts selected" : undefined}>
          <a
            onClick={props.selectedRows.length === 0 ? undefined : () => setShowBankAccountToEntitySetRelationModal(true)}
            style={{ cursor: props.selectedRows.length === 0 ? "not-allowed" : "pointer", }}
          >
            Assign to Entity
          </a>
        </Tooltip>,
        <Tooltip title={props.selectedRows.length === 0 ? "No accounts selected" : undefined}>
          <a
            onClick={props.selectedRows.length === 0 ? undefined : () => setShowUnassignEntityFromBankAccountsModal(true)}
            style={{ cursor: props.selectedRows.length === 0 ? "not-allowed" : "pointer", }}
          >
            Unassign from Entity
          </a>
        </Tooltip>,
        <Tooltip title={props.selectedRows.length === 0 ? "No accounts selected" : undefined}>
          <a
            onClick={props.selectedRows.length === 0 ? undefined : () => setShowUpdateAccountNumbersModal(true)}
            style={{ cursor: props.selectedRows.length === 0 ? "not-allowed" : "pointer", }}
          >
            Update Account Numbers
          </a>
        </Tooltip>
      )
    }

    setDropdownItems(newDropdownItems)
  }, [props.selectedRows, props.entities, props.bankAccounts, props.bankAccountsLoading, props.allAccounts, props.tableData]);

  return (
    <>
      <GenericDropdown
        dropdownItems={dropdownItems}
      />

      {showStatementModal && (
        <DownloadStatements
          visible={showStatementModal}
          handleCancelModal={() => setShowStatementModal(false)}
          selectedRows={props.selectedRows}
          allAccounts={props.allAccounts}
        />
      )}

      {showVerificationDocModal && (
        <DownloadVerificationDocs
          visible={showVerificationDocModal}
          handleCancelModal={() => setShowVerificationDocModal(false)}
          selectedRows={props.selectedRows}
          allAccounts={props.allAccounts}
        />
      )}

      {showAchWireDetailsModal && (
        <DownloadAchWireDetails
          visible={showAchWireDetailsModal}
          handleCancelModal={() => setShowAchWireDetailsModal(false)}
          selectedRows={props.selectedRows}
          tableData={props.tableData}
        />
      )}

      {showBankAccountToEntitySetRelationModal && (
        <EntityToBankAccountSetRelation
          selectEntities={props.entities}
          bankAccounts={props.selectedRows}
          visible={showBankAccountToEntitySetRelationModal}
          handleCancelModal={() => setShowBankAccountToEntitySetRelationModal(false)}
          handleRemove={props.handleRemove}
          assignEntityToBankAccounts={props.assignEntityToBankAccounts}
        />
      )}

      {showUnassignEntityFromBankAccountsModal && (
        <UnassignEntityFromBankAccounts
          bankAccounts={props.selectedRows}
          visible={showUnassignEntityFromBankAccountsModal}
          handleCancelModal={() => setShowUnassignEntityFromBankAccountsModal(false)}
          unassignEntityFromBankAccounts={props.unassignEntityFromBankAccounts}
        />
      )}

      {setShowUpdateAccountNumbersModal && (
        <UpdateAccountNumbers
          bankAccounts={props.selectedRows}
          visible={showUpdateAccountNumbersModal}
          handleRemove={props.handleRemove}
          handleCancelModal={() => setShowUpdateAccountNumbersModal(false)}
        />
      )}
    </>
  );
}

export default ConnectedAccountsTableDropdown